import { render, staticRenderFns } from "./RiskPermitSpecial.vue?vue&type=template&id=2aee610e&scoped=true&"
import script from "./RiskPermitSpecial.vue?vue&type=script&lang=js&"
export * from "./RiskPermitSpecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aee610e",
  null
  
)

export default component.exports